import { render, staticRenderFns } from "./ActivitiesOnDay.vue?vue&type=template&id=65a99fca&"
import script from "./ActivitiesOnDay.vue?vue&type=script&lang=js&"
export * from "./ActivitiesOnDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports